"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomText = CustomText;
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const mapRichText_1 = require("../componentMappers/mapRichText");
function CustomText({ content, tag, styleAs, mappers, }) {
    if (!content)
        return null;
    const style = styleAs?.toLowerCase()?.trim();
    const mappedContent = (0, mapRichText_1.mapText)(content?.root?.children?.[0], mappers);
    const richTextTag = content?.root?.children?.[0]?.tag;
    return ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Typography, { variant: style || 'body', rendersAs: (typeof richTextTag === 'string' && richTextTag?.toLowerCase()) || tag, children: mappedContent }));
}
exports.default = CustomText;
